import React, { useLayoutEffect } from "react";
import { connect } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { createBrowserHistory, useBasename } from "history";
import thunk from "redux-thunk";
import RequireAuth from "./components/auth/require_auth";
import { loadingBarMiddleware } from "react-redux-loading-bar";
import { errorBarMiddleware } from "ReduxErrorBar";
import { CSSTransitionGroup, TransitionGroup } from "react-transition-group";
import { getDeviceSize } from "Actions";

import Landing from "Landing";
import Choose from "Choose";
import Login from "Login";
import Signup from "Signup";
import Signup_Koachify from "./components/starter/signup_koachify";
import Dashboard from "Dashboard";
import Mobile from "Mobile";
import SignupLinkedin from "SignupLinkedin";
import TermsService from "./terms-service";
import ResetPassword from "ResetPassword";
import ProcessResetPassword from "ProcessResetPassword";
import Billingpayment from "./components/billpayment/index";
import Paymentthankyoupage from "./components/billpayment/paymentthankyou";

import "react-image-lightbox/style.css"; // This only needs to be imported once in your app
import reducers from "./reducers";
import { loadState, saveState } from "./localStorage";

var persistedState = loadState();
var createStoreWithMiddleware = applyMiddleware(
  thunk,
  loadingBarMiddleware(),
  errorBarMiddleware()
)(createStore);

export var store = createStoreWithMiddleware(reducers, persistedState);

store.subscribe(() => {
  saveState(store.getState());
});

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL, // The base URL of the app (see below)
  hashType: "slash", // The hash type to use (see below)
  forceRefresh: true,
});

const MainApp = (props) => {
  if (!props.isLoggedIn) {
    // this.props.history.push('/');
  }

  useLayoutEffect(() => {
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const updateSize = () => {
    // GETTING DYNAMIC HEIGHT AND WIDTH
    props.getDeviceSize();
  };

  return (
    <div className="full-height">
      <TransitionGroup>
        <CSSTransitionGroup
          transitionName="example"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
          appear={true}
          in={true}
        >
          <BrowserRouter>
            <Switch>
              <Route
                path="/dashboard"
                component={(props) => <Dashboard {...props} />}
              />
              <Route
                path="/reset"
                component={(props) => <ResetPassword {...props} />}
              />
              <Route
                path="/resetpwd"
                component={(props) => <ProcessResetPassword {...props} />}
              />
              <Route
                path="/billingpayment"
                component={(props) => <Billingpayment {...props} />}
              />
              <Route
                path="/payementthanyoupage"
                component={(props) => <Paymentthankyoupage {...props} />}
              />
              <Route
                path="/mobile"
                component={(props) => <Mobile {...props} />}
              />
              <Route
                path="/signup"
                component={(props) => <Signup_Koachify {...props} />}
              />
              <Route
                path="/login"
                component={(props) => <Login {...props} />}
              />
              <Route
                path="/preview"
                component={(props) => <Choose {...props} />}
              />
              <Route path="/" component={(props) => <Landing {...props} />} />
            </Switch>
          </BrowserRouter>
        </CSSTransitionGroup>
      </TransitionGroup>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
  };
}

export default connect(mapStateToProps, { getDeviceSize })(MainApp);
